<template>
   <div>
    <ul class="cb-slideshow ul2" style="list-style:none">
            <li><span>Image 01</span><div><h3>DURGA PUJA</h3></div></li>
            <li><span>Image 02</span><div><h3>KALI PUJA</h3></div></li>
            <li><span>Image 03</span><div><h3>SARASWATI PUJA</h3></div></li>
            <li><span>Image 04</span><div><h3>POILA BOISHAKH</h3></div></li>
            <li><span>Image 05</span><div><h3>SPORTS DAY</h3></div></li>
            <li><span>Image 06</span><div><h3>H  P  C  A</h3></div></li>
    </ul>
    <div class="container">
            <!-- Codrops top bar -->
            <div class="codrops-top">
                <!-- <a href="http://tympanus.net/Development/RockingLetters/">
                    <strong>&laquo; Previous Demo: </strong>Rocking Letters with CSS3 &amp; jQuery
                </a> -->
                <a href="#" style="cursor: not-allowed;">
                    REGISTERED CHARITY NO-1180289
                </a>
                <a></a>
                <span class="right">
                  <router-link to="/About"><font-awesome-icon icon="home" /> ..About</router-link>
                  <router-link to="/Objectives"><font-awesome-icon icon="bullseye" /> ..Objectives</router-link>
                  <router-link to="/Events"><font-awesome-icon icon="calendar-check" /> ..Events</router-link>
                  <router-link to="/Sponsor"><font-awesome-icon icon="hands-helping"/> ..Sponsor</router-link>
                  <router-link to="/Gallery/PhotoGallery"><font-awesome-icon icon="images" /> ..Gallery</router-link>
                  <router-link to="/Membersroundup"><font-awesome-icon icon="coffee" /> ..Members'Roundup</router-link>
                  <router-link to="/Contact"><font-awesome-icon icon="mobile-alt" /> ..Contact</router-link>
                </span>
                <div class="clr"></div>
            </div><!--/ Codrops top bar -->
            <header>
                <h1> <span>Hampshire Puja and Cultural Association</span></h1>
                <h2>Promoting Cultural Diversity and Community Cohesion Across Hampshire</h2>
            </header>
        </div>

   </div>
</template>

<script>

  export default {
    name: 'Home',
    data () {
      return {
        msg: 'Home',
        cricket: 'Cricket is a sport which is played between two teams of eleven players each who score runs (points) by running between two sets of three small, wooden posts called wickets. Each of the wickets is at one end of a rectangle of flattened grass called the pitch. Around the pitch is a much larger oval of grass called the cricket ground.',
        football: 'Football is a sport which is played between two teams of eleven players each The game is played by kicking a ball into the opponents goal. A match has 90 minutes of play, with a break of 15 minutes during the match. The 90 minutes of play also includes extra time. The break in the middle is called half-time.',
        
        currentNumber: 0,
        timer: null
    }
  },
  mounted: function () {
        this.startRotation();
  },
  methods: {
    greet: function (event) {
      // `this` inside methods point to the Vue instance
      alert('Hello ' + this.name + '!')
      // `event` is the native DOM event
      alert(event.target.tagName)
    //   this.$router.push({name:'Events', params:{id:id}});
    this.$router.push({name:'Events'});
    },
    startRotation: function() {
        this.timer = setInterval(this.next, 6000);
    },
    next: function() {
        this.currentNumber += 1
    },
    prev: function() {
        this.currentNumber -= 1
    }
  }
}

</script>

<style>
  .def {
    padding: 0 40px;
    max-width: 800px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue